import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import AssistanceAddModal from '../../containers/assistance/AssistanceAddModal'
import AssistanceEditCategoryModal from '../../containers/assistance/AssistanceEditCategoryModal'
import AssistanceList from '../../containers/assistance/AssistanceList'
import AssistanceSearch from '../../containers/assistance/AssistanceSearch'
import AddBtnIcon from '../icons/ui/AddBtn'
import ErrorBoundary from '../ErrorBoundary'

const AssistancePane = (props: RouteComponentProps<any>): any => {
  return (
    <ErrorBoundary>
      <section>
        <div className='bg-white'>
          <div className='pt3'>
            <div className='flex justify-between mb3 pl3'>
              <span className='h5 font-grey2'>ASSISTANCE LIST</span>
              <AssistanceSearch />
            </div>
            <AssistanceList />
          </div>
          <Route path={`${props.match.path}/add-category`} component={AssistanceEditCategoryModal} />
          <Route path={`${props.match.path}/create-assistance`} component={AssistanceAddModal} />

          <div className='ml2 pl2 bold font-small'>
            <Link to={`/assistance/add-category`}>+ Add/Edit Category</Link>
          </div>
          <div className='absolute bottom-0 right-0 p4'>
            <Link to={`/assistance/create-assistance`}>
              <AddBtnIcon className='icon--64x64 cursor--pointer' />
            </Link>
          </div>
        </div>
      </section>
    </ErrorBoundary>
  )
}

export default AssistancePane



// WEBPACK FOOTER //
// ./src/components/assistance/AssistancePane.tsx